import { VolumetricFlowCalculatorInput } from 'src/modules/user-input/calcVolumetricFlow/types.ts';
import { Decimal } from 'decimal.js-light';
import { getUnitByName } from 'src/modules/user-input/getUnitByName.ts';
import { MESSAGES } from 'src/modules/common/constants.ts';
import { convert } from 'src/modules/user-input/convert.ts';
import { targetUnits } from 'src/modules/user-input/targetUnits.ts';

export const getSteamErrorMessages = (input: VolumetricFlowCalculatorInput): string => {
    try {
        const inletDecimal = new Decimal(convert(
            input.inlet,
            getUnitByName(input.inlet_u, targetUnits.dpv100),
            targetUnits.dpv100,
        ));
        const outletDecimal = new Decimal(convert(
            input.outlet,
            getUnitByName(input.outlet_u, targetUnits.dpv100),
            targetUnits.dpv100,
        ));
        switch (true) {
            case inletDecimal
                .minus(outletDecimal)
                .dividedBy(inletDecimal)
                .greaterThan(0.4): {
                return MESSAGES.ErrorSteamRatioHigh;
            }
            case inletDecimal.greaterThan(500):
                return MESSAGES.ErrorSteamInletHigh;
            case outletDecimal.greaterThan(inletDecimal):
                return MESSAGES.ErrorSteamOutletHigh;
            default: {
                return '';
            }
        }
    } catch {
        return '';
    }
};
